export default "__VITE_ASSET__2tRR5qTH__"